import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AssigTripsService } from '../assigntrips-service/assigntrips-service';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';
import { takeUntil } from 'rxjs/operators';
import * as moment from 'moment-timezone';
import { ServiceAreasService } from '../../service-areas/service-areas-service/service-areas.service';
import { sweetAlert } from 'src/app/utils/swal';
import { CorporateService } from '../../corporate-user/corporate-service/corporate-service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';

@Component({
  selector: 'app-trip-activity-log',
  templateUrl: './trip-activity-log.component.html',
  styleUrls: ['./trip-activity-log.component.css']
})
export class TripActivityLogComponent implements OnInit {
  activityLog = [];
  search;
  user;
  @Input() tripData;
  @Output() onCloseModal = new EventEmitter<any>()

  preServiceAreas = {};
  preCooperates = {};


  constructor(
    private assignTripService: AssigTripsService,
    private serviceArea : ServiceAreasService,
    private corporateService: CorporateService,
    private sharedDataService: SharedDataService
  ) { }

  ngOnInit() {
    this.getTripLog();
    this.getServiceAreas();
    this.getCorporate();
    this.getUser();
  }

    getUser() {
      this.sharedDataService
        .getUser()
        .pipe(takeUntil(takeUntilDestroyed(this)))
        .subscribe((data) => {
          if (data) {
            this.user = data;
          }
        });
    }

  getTripLog() {
    this.assignTripService.getTripActivityLog(this.tripData._id)
      .pipe(takeUntil(takeUntilDestroyed(this))).subscribe((data) => {
        if (data) {
          this.activityLog = data
        }
      })
  }

  getServiceAreas(){
    this.serviceArea.getServiceAreas({status: 'active'})
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.preServiceAreas = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
    }

    getCorporate() {
      this.corporateService
        .getCorporateUsers('active')
        .pipe(takeUntil(takeUntilDestroyed(this)))
        .subscribe(data => {
          if (data ) {
            this.preCooperates = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        }, err => {
          sweetAlert('Error', err, 'warning', 'OK');
        });
    }


  onClose() {
    this.onCloseModal.emit()
  }

  formateLogs(log) {
    if (this.user && log) {
      const timeZone = this.user.company ? this.user.company.timeZone : this.user.timeZone;
      log = log.replace(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})?/g, (match) => {
        const nyTime = moment(match).tz(timeZone).format("YYYY-MM-DD HH:mm");
        return `${match} (<b>${nyTime} ${timeZone}</b>)`;
      });



      if (this.preCooperates) {
        log = log.replace(/(?:cooperate:|->)\s*([a-f0-9]+)/gi, (match, id) => {
          if (this.preCooperates[id] && this.preCooperates[id].displayName) {
            return match.replace(id, `${id} (<b>${this.preCooperates[id].displayName}</b>)`);
          }
          return match; // leave unchanged if no displayName
        });
      }

    }

    return log;
  }

  ngOnDestroy(): void {

  }
}
